/**
 * @description Enum para tipos de personalidad fiscal
 * @author Omar Sánchez Martínez
 * @since 2025-06-26
 */

export enum Personalidad {
  FISICA = 'Física',
  MORAL = 'Moral',
}

export type PersonalidadType = 'fisica' | 'moral';
